module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "cdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Hainan Island, China")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Zeus emptied his mind as he walked,")]), _vm._v(" focusing entirely on his surroundings. The airport was a collection of bright lights and shadows, blinking beacons and looming buildings. The runway was a good distance away, more than a hundred yards. Beyond it were four black lumps—military hangars, he guessed, as the other half of the airport was used by the People’s Liberation Army’s air force.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("So don’t run that way when you make your break.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Light from the interior of the terminal building washed over the apron where the planes were parked, tinting everything yellow. The planes themselves were unlit, seemingly without power or crews. That killed any temptation he might have had to fantasize about boarding one and hijacking it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And there were simply too many soldiers around to think about running, much less overpowering them. Another truck crossed ahead at the end of the terminal building; as it passed, a floodlight on the building illuminated the faces of five men hanging from the back, giving them a ghostly pallor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What, do they have the whole damn Chinese army here?” grumbled Christian, a little louder than Zeus would have liked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They’re under attack, remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What the hell are we going to do?” Christian asked. “Where are they taking us?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Zeus had no answers. Better to go along, say nothing, hope for the best.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Hope isn’t a plan.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That was his tactical instructor’s motto at West Point. Zeus wondered how he’d deal with this. That was one thing they didn’t teach you at the Point: how to be a successful spy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As they drew parallel to the end of the terminal gate building, the soldier leading them turned right about forty-five degrees, and began walking across a long, open area toward another building. A row of armored personnel carriers sat to his right, about thirty yards away, blocking off part of the apron area.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Zeus went into G-2 mode, assessing the vehicles as an intelligence officer would. They were short and squat, with turrets toward the rear of the hull: NVH-1s, very old vehicles, with 30 mm or 25 mm guns in the turret. They’d hold nine soldiers, plus two crewmen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’d expect older gear on Hainan, so that fit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Had they been upgraded? The Chinese got a lot of use out of their older vehicles by outfitting them with the latest technology.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A single radio whip off the turret.")]), _vm._v(" Not enough to go on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So where had they come from?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Probably they were kept on the military side and just rushed over, assigned to take up positions in case the Vietnamese counterattacked. It would be standard procedure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How many?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One company at least. How many had he passed now? How many were on the other side of the building?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Were they army or air force? How were the Chinese divisions organized—would these be attached to a regular division, or a separate unit?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There were two self-propelled antiaircraft guns in the distance, close to the runway; he could see the barrels rising above the hulls.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Two barrels. Which made them … what?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Russian ZSU-57s?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No way. Too old.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They weren’t aligned very well for defense. The positioning was the sort of thing you would see if you were expecting some sort of civil disturbance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were still in that mode, not quite ready for the war they were actually fighting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A vehicle moved from the shadows ahead. It had its running lights but not its headlights on. At first glance, Zeus thought it was a sedan, but as it approached he realized it was a crew cab pickup. There were soldiers standing in the back, leaning over the roof.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The man who had been leading them raised his hand as it pulled up. There were two soldiers sitting in the front seat. The man opened the rear passenger side door and gestured toward Zeus.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We can’t get in,” whispered Christian. “Who the hell knows where they’re taking us?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We don’t really have much choice at this point,” Zeus told him. “Just relax. We’ll get through this.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Fuck you, relax.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Listen to me. Just play along—we’re businessmen. Do not change your story.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Businessmen get arrested by half the army?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Zeus climbed in. The cab smelled funny—like roasted peanuts, he thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Neither of the two men in front said anything. The soldiers who had escorted them slammed the door shut after Christian got in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What the hell?” hissed Christian.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Zeus shook his head. The truck started forward in a gentle glide, barely moving at first, then gradually picking up speed. It moved toward the terminal building, on the opposite side from where they’d come out. The personnel carriers were on their right. Then the driver found a road marked with reflectors across the wide asphalt concourse and turned sharply. Their speed gradually increased as they moved away from the terminal building. They passed some maintenance vehicles, then slowed as they approached a hangar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A two-engined Fokker 50 passenger plane sat out front. The truck stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Zeus pulled the door handle next to him, only to find it was secured by a lock that allowed it to be opened only from the outside.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They sat in the dark for a moment. Zeus considered the odds of overpowering both men in the front. He could strangle the driver easily enough; could Christian take the other?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Push the man aside, flip over the seat—he’d probably be able to make it before anyone in the bed behind them or outside could react. Once in the driver’s seat, he could simply back up, drive around to the front.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Desperation move.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Was it better than just doing nothing?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was just turning to Christian, intending on miming what he wanted to do, when the door next to him opened.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was Solt Jan. “Out. On the plane. Let’s go!” she ordered.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb2"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Zeus took a slow breath")]), _vm._v(" as he pushed out of the truck. Solt was already halfway to the plane.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What the hell?” asked Christian under his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Zeus followed Solt to the stairs leading to the aircraft. He walked deliberately, trying to observe the surroundings without being too obvious. There were some mechanics or maintenance personnel in the hangar, but no soldiers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He glanced back at Christian, who was still back near the truck.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Was Christian thinking of making a break for it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t, thought Zeus. Play this through.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Christian started walking. He was mumbling when he reached the steps.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m hungry,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“There’s probably food on the plane.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Zeus went up and found Solt waiting just inside the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Take the seats in row six,” she whispered. She handed him their passports. “Say nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Where are we going?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Say nothing,” she hissed. “Good luck.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-578e5868","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter7.vue
// module id = 104
// module chunks = 0